import ResultsCount from "components/components/ResultsCount/ResultsCount";
import SortableTable, {
  TableCellRender,
} from "components/components/SortableTable/SortableTable";
import { NoWrapCell } from "components/components/SortableTable/style";
import { RestorationZoneDemandRestoredTableModel } from "models/restorationZone/restorationZoneDemandRestored";
import React from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";

interface Props {
  data?: RestorationZoneDemandRestoredTableModel[];
}

const RestorationZoneDemandRestoredTable: React.FC<Props> = ({ data }) => (
  <>
    <ResultsCount count={data ? data.length : 0} />
    <SortableTable
      headers={{
        submissionDateTime: "Submission Date Time (UTC)",
        region: "Region",
        gspGroupId: "GSP Group ID",
        restoredDemand: "Restored Demand (MW)",
      }}
      items={data ?? []}
      renderFns={{
        submissionDateTime: (el): TableCellRender => ({
          content: (
            <NoWrapCell>
              {formatDateTimeString(el.submissionDateTime, DateFormat.DateTime)}
            </NoWrapCell>
          ),
        }),
      }}
      dataTestId="restoration-zone-demand-restored-table"
      scrollable={false}
    />
  </>
);

export default RestorationZoneDemandRestoredTable;
